export default "__VITE_ASSET__vG5ic4ld__"